import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'opcoes'
})
export class OpcoesPipe implements PipeTransform {

  transform(value: Array<any>, args?: any): any {

    if(!value || !value.length)
      return "";

    return value.map( (element) => element.descricao).reduce((anterior, atual) => {
      return anterior+" <br> "+ atual;
    });
  }

}
